<script setup lang="ts">
definePage({ meta: { hideInMenu: false } });
</script>

<template>
  <div>Home Page</div>
</template>
